export const iconFontAwesomeMapsDiamondTurnRight = (
	<i className="fa-solid fa-diamond-turn-right"></i>
);
